import { Text } from '@kanda-libs/ks-design-library';

import Container from './Vat-container';

const ViewComponent = ({}) => (
  <Container>
    {({ vat, isLoading, classNames }) => (
      <Text className={classNames.vat} isLoading={isLoading} text={vat} />
    )}
  </Container>
);

ViewComponent.displayName = 'LineItem-Vat-view';

export default ViewComponent;
